import { render, staticRenderFns } from "./ModifyOrderDrawer.vue?vue&type=template&id=20143458&scoped=true&"
import script from "./ModifyOrderDrawer.vue?vue&type=script&lang=js&"
export * from "./ModifyOrderDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20143458",
  null
  
)

export default component.exports